var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { isolateComponent } from '@zapier/style-encapsulation';
import { BaseButton, } from '../../navigation/Button/BaseButton';
import { VisuallyHidden } from '../../display/VisuallyHidden';
export function BrandButton(_a) {
    var { color = 'brand', size = 'small' } = _a, props = __rest(_a, ["color", "size"]);
    return color === 'brand-nav' ? (isolateComponent(BaseButton, { color: "brand-nav", iconBefore: props.iconBefore || 'formAdd', size: "medium" },
        isolateComponent(VisuallyHidden, null, props.children || 'Create a Zap'))) : (isolateComponent(BaseButton, Object.assign({ color: color, size: size }, props)));
}
//# sourceMappingURL=BrandButton.js.map
// @zapier/design-system@6.1.0 (fd86aa2ab)
